// select 搜索框搜索时根据名称搜索
export function selectFilterOption(input, option) {
    return option.componentOptions.children[0].text.indexOf(input) >= 0;
}

export function ratioFormatter(value) {
    return value + "%";
}